import $ from 'jquery'; // Importa jQuery
import Swal from 'sweetalert2'; // SweetAlert2
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Bootstrap

window.$ = window.jQuery = $; // Rendi jQuery disponibile globalmente
window.Swal = Swal; // Rendi SweetAlert2 disponibile globalmente

require('./all'); // Mantieni questa riga